var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSmallSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137,
    height: 92,
    viewBox: "0 0 137 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 137,
    height: 92,
    rx: 4,
    transform: "translate(784.916 19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-784.916 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.21 110.029) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(947 480)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14,3V14.556a2.889,2.889,0,0,0,2.889,2.889H28.444",
    transform: "translate(12 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M39.667,55H10.778A5.778,5.778,0,0,1,5,49.222V8.778A5.778,5.778,0,0,1,10.778,3H31L45.444,17.444V49.222A5.778,5.778,0,0,1,39.667,55Z",
    transform: "translate(-5 -3)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 1.926,
    transform: "translate(956.63 503.111)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 21.185,
    transform: "translate(956.63 510.815)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 21.185,
    transform: "translate(956.63 518.518)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSmallSymbol);
export default __webpack_public_path__ + "static/media/file-small-symbol.aabc685d9cef6a5eeb93eeb94cdd5a13.svg";
export { ForwardRef as ReactComponent };